import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/Button';

interface ButtonsProps {
  loading: boolean;
  actionTwoLoading: boolean;
  view: boolean;
  onSubmit: (action: '1' | '2', e?: React.FormEvent) => void;
  onCancel: () => void;
}

const Buttons: React.FC<ButtonsProps> = ({
  loading,
  actionTwoLoading,
  view,
  onSubmit,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <div className="p-4">
      {
        !view && <Button
          className="btn btn-primary me-3"
          text={t("invoices.editPreviewPayment.pageTexts.form.detailsTab.buttons.save")}
          disabled={loading || actionTwoLoading}
          loading={loading}
          onClick={() => onSubmit('1')}
        />
      }

      {
        !view && <Button
          className="btn btn-primary me-3"
          text={t("invoices.editPreviewPayment.pageTexts.form.detailsTab.buttons.saveAndPreview")}
          disabled={loading || actionTwoLoading}
          loading={actionTwoLoading}
          onClick={() => onSubmit('2')}
        />
      }

      <Button
        className="btn btn-outline-secondary"
        text={t("invoices.editPreviewPayment.pageTexts.form.detailsTab.buttons.cancel")}
        onClick={onCancel}
      />
    </div>
  );
};

export default Buttons;
